module.exports = __webpack_public_path__ + "img/ts22.a97a661c.png";